//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/AME.js";
import "../no/Builder.js";
let d=[[[0,"ClassificationItem",0,"AME.SelectClassificationBuilder",0],[0,"NameInFunction",1,0],[0,"NameInLocation",1,0],[0,"NameInProduct",1,0],[0,"SameNameInAllAspect",1,0],[0,"SelectLibraryObject",0,"AME.SelectionBaseDefinitionBuilder",0]],[[["startIndex","increment","displayDigits"],"FillFunctionAspectData",{},3,0],[["startIndex","increment","displayDigits"],"FillLocationAspectData",{},3,0],[["startIndex","increment","displayDigits"],"FillProductAspectData",{},3,0],[[],"CreateOrUpdateNamingRuleAndSetData",{},0,0],[["namingRuleTag"],"RemoveNamingRule",{},1,0]],[]];
SPLM.AME.NamingSchemeAspectNamingBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.AME.NamingSchemeAspectNamingBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;